import { AxiosError, AxiosHeaders,AxiosRequestConfig,AxiosResponse,AxiosInstance } from 'axios';
import axios  from 'axios';
import { useAppDispatch } from '../reduxToolkit/hooks';
import { logout } from '../reduxToolkit/reducers/layout/authSlice';
import { store } from '../reduxToolkit/store';
import { useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// Create axios instance with default config
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 40000,   // ✅ 40 sec — backend ke 3×10s retry se thoda zyada

    headers: new AxiosHeaders( {
        'Content-Type': 'application/json',
        
    },)
    
});

  axiosInstance.interceptors.request.use((config)=>{
      
    const token = sessionStorage.getItem('Auth-Token');
     
    if(token){
        if(!config.headers || typeof config.headers.set !== 'function')
         {
            config.headers = new AxiosHeaders(config.headers);
             
         }
         config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  })

  //throw to logout when token expire 

  axiosInstance.interceptors.response.use(
    (response)=> response,
    (error)=>{
         if(error.response?.status == 401){
            sessionStorage.removeItem('Auth-Token')
            store.dispatch(logout())
            
            window.location.href = '/login';
         }
         return Promise.reject(error);
    }
)


class ApiService {
    public static  async axiosApi(endpoint: string, options: any = {}) {
        try {
            const response = await axiosInstance(endpoint, options);
            return {
                success: true,
                data: response.data
            };
        } catch (error: any) {
            return{
                
                success: false,
                status: error.response?.status || 500,
                message: error.response?.data?.message || error.message || 'An error occurred',
                data: error.response?.data || null
            };
        }
    }
}


export default ApiService;